import { Typeahead } from "react-bootstrap-typeahead";
import "./Typeahead.css";
import { AUTOCOMPLETE_ITEM_PADDING_STYLE } from "../../utils/types";

//https://www.npmjs.com/package/react-bootstrap-typeahead
//https://github.com/ericgio/react-bootstrap-typeahead

export default function AutocompleteSingle(props) {
  // Custom renderMenuItemChildren to add padding for single-select dropdowns
  const renderMenuItemChildren = (option, menuProps, index) => {
    const label = typeof props.labelKey === 'function'
      ? props.labelKey(option)
      : option[props.labelKey] || option;

    return (
      <div style={AUTOCOMPLETE_ITEM_PADDING_STYLE}>
        {label}
      </div>
    );
  };

  return <Typeahead size="sm" placeholder={props.placeholder}  id={"id" + props.reactKey}  key={props.reactKey}
    clearButton labelKey={props.labelKey} onChange={props.onChange} options={props.options}
    style={props.style} selected={props.selected} inputProps={props.inputProps} onBlur={props.onBlur}
    renderMenuItemChildren={renderMenuItemChildren}
    />;
}

